"use client";
import React from "react";
import TipCard from "./TipCard";

const TipSection = () => {
  return (
    <section className="mt-6 w-full">
      <div className="w-full">
        <div className="pl-3 w-full">
          <h2 className="w-full text-lg font-semibold leading-loose text-gray-900">
            <div className="flex gap-4 w-full">
              <span className="flex-1 shrink w-full basis-0 min-w-60">
                Personalized Tips
              </span>
            </div>
          </h2>
          <div className="flex gap-4 items-end mt-4 w-full whitespace-nowrap">
            <p className="text-3xl font-semibold leading-none text-gray-900">
              247L
            </p>
            <div className="pb-2 text-sm font-medium leading-none text-center text-emerald-700">
              <div className="flex gap-1 items-center py-0.5 pr-2.5 pl-2 bg-emerald-50 rounded-full border border-emerald-200 border-solid">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/af073f4a61c83535a7896111dbbef16a1b01b1b6?placeholderIfAbsent=true"
                  alt="Increase"
                  className="object-contain shrink-0 self-stretch my-auto w-3 aspect-square"
                />
                <span className="self-stretch my-auto">
                  7.2%
                </span>
              </div>
            </div>
          </div>
        </div>

        <TipCard
          imageUrl="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/7f625e1c79b666a13d3e0d82b79da0d875317c0e?placeholderIfAbsent=true"
          badgeText="Shorter Showers"
          description="Reduce shower time by 2 mins to save 15L per shower"
        />

        <TipCard
          imageUrl="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/5d9ba2832a13435439c685e0820b801486c32ddb?placeholderIfAbsent=true"
          badgeText="Fix That Leak"
          description="A dripping faucet wastes up to 20L per day"
        />
      </div>
    </section>
  );
};

export default TipSection;
